import { Input } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { changeEmail } from './email-api';
import { ChangeEmailFormProps } from './email.types';
import { StyledBtn, StyledInput } from './styles';

const ChangeEmailForm = ({ onConfirm, initialEmail }: ChangeEmailFormProps) => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const { t: translation } = useTranslation();

  const changeEmailField = (event: React.FormEvent<HTMLInputElement>) => {
    setEmail(event.currentTarget.value);
  };

  const changePasswordField = (event: React.FormEvent<HTMLInputElement>) => {
    setPassword(event.currentTarget.value);
  };

  const onConfirmClicked = async () => {
    setIsLoading(true);
    setError('');
    try {
      await changeEmail({
        email,
        password,
      });
      onConfirm(email);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);

        return;
      }

      setError('Failed to change email');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <StyledInput
        value={email}
        placeholder={translation('base.newEmail')}
        defaultValue={initialEmail}
        onChange={changeEmailField}
        autoFocus={true}
      />
      <Input.Password value={password} placeholder={translation('base.password')} onChange={changePasswordField} />
      {error && <div className='text-sm text-destructive'>{error}</div>}
      <StyledBtn type='primary' loading={isLoading} onClick={onConfirmClicked}>
        {translation('base.submit')}
      </StyledBtn>
    </>
  );
};

export default ChangeEmailForm;
